const paymentTypeOptions = {
  Owner: [
    {
      type: 'card',
      label: 'CARD',
    },
    {
      type: 'cheque',
      label: 'CHEQUE',
    },
    {
      type: 'cash',
      label: 'CASH',
    },
  ],
  OwnerAsBroker: [
    {
      type: 'card',
      label: 'CARD',
    },
    {
      type: 'cheque',
      label: 'CHEQUE',
    },
    {
      type: 'cash',
      label: 'CASH',
    },
    {
      type: 'account',
      label: 'BROKER ACCOUNT',
    },
  ],
  Broker: [
    {
      type: 'card',
      label: 'CARD',
    },
    {
      type: 'account',
      label: 'BROKER ACCOUNT',
    },
  ],
};

export default function getPaymentOptions(type) {
  return paymentTypeOptions[type];
}
